<template>
    <v-card :color="backgroundColor"
            height="325"
            :style="enabledModel ? 'border-left: 5px solid #070' : 'border-left: 5px solid grey'">

        <v-card-text>

            <div>
                <v-switch
                    class="mt-1 pt-0"
                    v-model="enabledModel"
                    label="Enable"
                    color="primary"
                    @change="toggled"
                ></v-switch>
            </div>

            <v-select
                v-model="operationModel"
                :items="dynamicBooleanOperations"
                label="Condition"
                @change="validate"
            ></v-select>

            <div class="pt-0 pb-2 caption">
                Status
            </div>

            <div class="mb-4">
                <project-status-selector v-model="statusesModel"
                                         :disable-statuses="disableStatuses"
                                         @input="validate"
                ></project-status-selector>
            </div>

            <div class="pt-0 pb-2 caption">
                In the following project(s)
            </div>

            <!-- SELECTED PROJECTS -->
            <v-sheet rounded
                     v-if="selectedProjects.length > 0"
                     class="d-flex flex-wrap pa-2 cursor-pointer"
                     color="grey darken-3"
                     @click="selectProjectsClicked"
            >

                <div v-for="selectedProject in selectedProjects"
                     :key="selectedProject.id"
                     class="d-flex flex-wrap"
                >
                    <v-tooltip color="primary" top>
                        <template v-slot:activator="{ on }">

                            <div v-on="on" class="align-self-center ma-1 d-flex">
                                <v-chip label class="align-self-center mr-1" small>
                                    {{ selectedProject.id }}
                                </v-chip>
                                <div class="align-self-center text-no-wrap mr-2">
                                    {{ selectedProject.name }}
                                </div>
                            </div>
                        </template>
                        Click here to select projects
                    </v-tooltip>
                </div>

            </v-sheet>

            <!-- SELECTOR WHEN NOTHING IS SELECTED -->
            <v-sheet rounded
                     max-width="300"
                     class="d-flex pa-2 cursor-pointer"
                     color="grey darken-3"
                     @click="selectProjectsClicked"
                     v-if="!idsModel || idsModel.length === 0">

                <div class="align-self-center">

                    <v-icon>mdi-chevron-down</v-icon>
                </div>

                <div class="align-self-center pl-3">
                    Click here to select projects
                </div>
            </v-sheet>

        </v-card-text>

        <project-selector v-model="projectSelectorDialogModel"
                          :selected="idsModel"
                          @selected="projectsSelected"
                          :projects="getFilteredProjects"
        ></project-selector>

    </v-card>

</template>

<script>

import ProjectSelector from "./ProjectSelectorDialog";
import Json from 'vue-json-pretty';
import Store from "../../ProjectManager/store";
import {mapState, mapGetters, mapActions} from 'vuex';
import Avatar from "../../../components/UI/Avatar";
import ProjectStatusSelector from "./ProjectStatusSelector";

export default {

    components: {
        ProjectStatusSelector,
        Avatar,
        ProjectSelector,
        Json
    },

    props: {
        active: {
            type: Boolean,
            required: true,
            default: false,
        },
        statuses: {
            type: Array,
            required: true,
        },
        projectIds: {
            type: Array | null,
            required: false,
            default: () => []
        },
        operation: {
            type: String,
            required: false,
            default: 'must',
            validation: (operation) => ['must', 'must_not'].includes(operation)
        },
        backgroundColor: {
            type: String,
            required: false,
            default: 'grey darken-2'
        },
        excludeOnly: {
            type: Boolean,
            required: false,
            default: false
        },
        excludeOnlyText: {
            type: String,
            required: false,
            default: 'Terminate panelists who have'
        },
        disableStatuses: {
            type: Array,
            required: false,
            default: () => []
        }
    },

    data() {
        return {
            enabledModel: false,
            idsModel: [],
            statusesModel: ['completed'],
            operationModel: 'must',

            projectSelectorDialogModel: false,
            booleanOperations: [
                {text: 'Include panelists who have', value: 'must'},
                {text: 'Exclude panelists who have', value: 'must_not'}
            ],
        }
    },

    computed: {

        ...mapState('ProjectManager', [
            'projects',
            'projectsLoading'
        ]),

        ...mapGetters('ProjectManager', [
            'getFilteredProjects'
        ]),

        selectedProjects() {
            return this.projects.filter(project => this.idsModel.includes(project.id));
        },

        dynamicBooleanOperations() {
            if (this.excludeOnly) {
                return [{text: this.excludeOnlyText, value: 'must_not'}];
            }
            return this.booleanOperations;
        }
    },

    methods: {

        ...mapActions('ProjectManager', [
            'loadProjects'
        ]),

        validate() {
            if (this.enabledModel && this.idsModel.length > 0 && this.statusesModel.length > 0) {
                this.emit();
            }
        },

        selectProjectsClicked() {
            this.projectSelectorDialogModel = true;
            this.validate();
        },

        toggled(enabled) {
            if (enabled) {
                if (this.idsModel.length === 0) {
                    this.$nextTick(() => {

                        Bus.$emit('flash-message', {
                            type: 'error',
                            location: 'bottom',
                            message: 'Filter cannot be applied till you select at least one project!'
                        });
                    });
                }
                this.validate();
            } else {
                this.emit();
            }
        },

        projectsSelected(ids) {
            this.idsModel = ids;
            this.validate();
        },

        loadModels() {
            this.enabledModel = this.active;
            this.idsModel = this.idsModel ? [...this.projectIds] : [];
            this.statusesModel = [...this.statuses];
            this.operationModel = this.operation;
        },

        emit() {

            const data = {
                projectFilterActive: this.enabledModel,
                projectFilterIds: this.idsModel,
                projectFilterStatuses: this.statusesModel,
                projectFilterOperation: this.operationModel,
            };

            this.$emit('change', data);
        }
    },

    mounted() {
        this.loadProjects({force: false})
            .then(() => {
                this.loadModels();
            });
    },

    created() {
        if (!this.$store.state.ProjectManager) {
            this.$store.registerModule('ProjectManager', Store);
        }
    },
}
</script>
